import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

// Placeholder API endpoints
export const newsletterOverview = {
  dashboard: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/newsletter_overview", params),
  onboarding: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/newsletter_overview/onboarding", params),
};
